import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface RevokeConsentModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const RevokeConsentModal = ({ open, onOpenChange, onConfirm }: RevokeConsentModalProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Révoquer votre consentement ?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              Vous êtes sur le point de révoquer votre consentement aux Conditions Générales d'Utilisation et à la Politique de Confidentialité.
            </p>
            <p className="font-semibold text-foreground">
              Conséquences :
            </p>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>Vous ne pourrez plus effectuer de recherches sur le site</li>
              <li>Vous devrez accepter à nouveau les CGU pour utiliser le service</li>
              <li>Un enregistrement de révocation sera conservé dans notre base de données</li>
            </ul>
            <p className="text-sm text-muted-foreground mt-4">
              Cette action est réversible - vous pourrez accepter à nouveau les conditions à tout moment.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive hover:bg-destructive/90"
          >
            Révoquer le consentement
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RevokeConsentModal;